<script lang="ts" setup>
import ClientPortal from './ContentPages/ClientPortal.vue'
import HantecMobile from './ContentPages/HantecMobile.vue'
import HantecSocial from './ContentPages/HantecSocial.vue'
import HantecWebTrader from './ContentPages/HantecWebTrader.vue'
import MetatraderDesktop from './ContentPages/MetatraderDesktop.vue'
import MetatraderMobile from './ContentPages/MetatraderMobile.vue'

defineProps({
  activeLink: {
    type: String
  },
  platformData: {
    type: Object
  }
})
</script>
<template>
  <div>
    <HantecSocial :data="platformData" v-if="activeLink === 'hantecSocial'"></HantecSocial>
    <HantecMobile :data="platformData" v-if="activeLink === 'hantecMobile'"></HantecMobile>
    <HantecWebTrader :data="platformData" v-if="activeLink === 'hantecWebTrader'"></HantecWebTrader>
    <MetatraderMobile
      :data="platformData"
      v-if="activeLink === 'metatraderMobile'"
    ></MetatraderMobile>
    <MetatraderDesktop
      :data="platformData"
      v-if="activeLink === 'metatraderDesktop'"
    ></MetatraderDesktop>
    <ClientPortal :data="platformData" v-if="activeLink === 'clientPortal'"></ClientPortal>
  </div>
</template>
